import { GoogleAuthProvider, connectAuthEmulator, getAuth } from "firebase/auth";

import { app } from "./app";

export const auth = getAuth(app);

if (import.meta.env.VITE_USE_EMULATORS === "true") {
  connectAuthEmulator(auth, "http://localhost:9099");
}

export const googleAuthProvider = new GoogleAuthProvider();
